import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import {enums} from 'types/enums';
import {useFormContext} from 'react-hook-form';

type Props = {
   status: string;
   name: string;
   disabled?: boolean;
};
export const OverwriteStatusCheckbox = ({name, status, disabled}: Props) => {
   const {setValue} = useFormContext();
   return (
      <Checkbox
         checked={status === enums.overwriteStatus.enum.TRUE}
         name={name}
         value={enums.overwriteStatus.enum.TRUE}
         onChange={(ev) =>
            setValue(
               name,
               ev.target.checked
                  ? enums.overwriteStatus.enum.TRUE
                  : enums.overwriteStatus.enum.FALSE
            )
         }
         disabled={disabled}
      />
   );
};
